//author: renjie
//2022.12.28
//点击所有广告位的通用处理方法

import cookies from 'src/utils/cookie';
import { fetchJson } from './fetch';
import { xflowPushEvent } from './pageTrack';

type AdClickProps = {
  adRequestUrl: string,
  adType: number | string,
  adName: string,
  adPosition: string,
  adNo: string,
  callback?: any,
  appId?: string,
  extraData: object,
  /** 半弹窗图片 URL，adType=4 时使用 */
  popupAttachmentDownloadUrl?: string,
  /** adType=4 时的回调，调用方负责控制弹窗显示 */
  onHalfPopup?: (imageUrl: string) => void,
}

export const onAdClick = (props: AdClickProps) => {
  const {adRequestUrl, adType, adName, adPosition, adNo, callback, appId, extraData, popupAttachmentDownloadUrl, onHalfPopup} = props;
  // 半弹窗：不走服务包检查，直接触发回调
  if (adType.toString() === '4') {
    onHalfPopup && onHalfPopup(popupAttachmentDownloadUrl || '');
    callback && callback();
    return;
  }
  pushXFlowEvent({adPosition, adName})
  //检查该广告位下是否有自动发放的服务包
  fetchJson({
    url: '/api/api/v1/patient/servpack/list',
    type: 'POST',
    data: {
      adPosition: adPosition,
      adNo: adNo
    },
    isloading: true,
  }).then(res => {
    if(res.code === '0' && res.result){
      //如果有服务包,则去对应页面处理逻辑,该页面需要登录，以此确保发放服务包时为登录状态
      if(res.result.length > 0){
        const servpackCodeList = res.result.map(item => item.servpackCode).join(',');
        window.reactHistory.push({
          pathname: '/hospital/middlepage/autoservpack',
          search: `adType=${adType}&adPosition=${adPosition}&adNo=${adNo}&servpackCodeList=${servpackCodeList}&adRequestUrl=${encodeURIComponent(adRequestUrl)}`
        })
      }else{
        pushUrl({adType, adRequestUrl, appId, extraData})
      }
    }else{
      // 即使请求失败也跳，不要影响正常流程
      pushUrl({adType, adRequestUrl, appId, extraData})
    }
    callback && callback()
  })
}
export const pushUrl = ({adType, adRequestUrl, appId, extraData}) => {
  if (adType.toString() === '2') {
    /**  component/app组件里面有一个判断进首页没有带渠道就会跳转错误页面的逻辑，所以对于外链跳转设置一个缓存标示，回来的时候有这个标示就不强制校验渠道  */
    cookies.set('jumpToThird', 'Y');
    window.location.href = adRequestUrl;
  }else if (adType.toString() === '3') {
    // 小程序链接
    if (appId === 'wx3c564538ea8e3905') {
      wx.miniProgram.navigateTo({
        url: adRequestUrl,
      });
    } else {
      wx.miniProgram.navigateTo({
        url: `/pages/middleMiniapp?appId=${appId}&envVersion=trial&path=${encodeURIComponent(adRequestUrl)}&extraData=${extraData}`,
      });
    }
  }
}
export const redirectUrl = ({adType, adRequestUrl, appId, extraData}) => {
  if (adType.toString() === '2') {
    /**  component/app组件里面有一个判断进首页没有带渠道就会跳转错误页面的逻辑，所以对于外链跳转设置一个缓存标示，回来的时候有这个标示就不强制校验渠道  */
    cookies.set('jumpToThird', 'Y');
    window.location.replace(adRequestUrl)
  }else if (adType.toString() === '3') {
    // 小程序链接
    if (appId === 'wx3c564538ea8e3905') {
      wx.miniProgram.redirectTo({
        url: adRequestUrl,
      });
    } else {
      wx.miniProgram.redirectTo({
        url: `/pages/middleMiniapp?appId=${appId}&envVersion=trial&path=${encodeURIComponent(adRequestUrl)}&extraData=${extraData}`,
      });
    }
  }
}
// XFLOW埋点
export const pushXFlowEvent = ({adPosition, adName}) => {
  if(adPosition === 'banner'){
    xflowPushEvent(['click', 'ZAHLWYY_SY', '首页', { ZAHLWYY_CLICK_CONTENT: `首页_banner${adName}` }]);
  }else if(adPosition === "rights_page_bottom_message"){
    xflowPushEvent(['click', 'ZAHLWYY_QYY', '我的权益页', { ZAHLWYY_CLICK_CONTENT: `我的权益页_banner${adName}` }]);
  }
}